import React, { useState, useEffect, useRef } from "react";
import { Button, DatePickerComp, Textarea } from "../../components/Form";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { deleteRegistroVacuna } from "../../redux/features/registroVacunasSlice";

// Este componente representa el modal de registro de vacuna.
// Recibe props para controlar su visibilidad, cerrar, guardar datos y la información de la vacuna.
const RegistroVacunaModal = ({
  isOpen, // Booleano que indica si el modal debe estar abierto o cerrado
  onClose, // Función que se llama cuando el modal debe cerrarse
  onSave, // Función que se llama al guardar los datos del registro
  vacunaData = {}, // Objeto con datos de la vacuna (ej: { id, name, dosisInfo })
}) => {
  // Estados para los campos del formulario del modal
  const [fechaAplicacion, setFechaAplicacion] = useState(new Date());
  /* const [lote, setLote] = useState(""); */
  /* const [observaciones, setObservaciones] = useState(""); */

  // useRef para obtener una referencia al elemento DOM del modal,
  // lo cual es necesario para inicializar y controlar el modal de Bootstrap con JavaScript.
  const modalElementRef = useRef(null);

  const {
    register,
    handleSubmit: hookFormHandleSubmit,
    setValue,
    getValues,
    reset, // Función para resetear el formulario
    trigger, // Función para disparar validaciones manualmente
    formState: { errors },
  } = useForm({
    defaultValues: {
      observacion: vacunaData.observacion || "",
    },
  });

  const dispatch = useDispatch();

  // Efecto que se ejecuta cuando 'isOpen' o 'vacunaData' cambian.
  // Se usa para resetear el formulario cuando el modal se abre o cuando se cambia la vacuna.
  useEffect(() => {
    if (isOpen) {
      setFechaAplicacion(
        vacunaData.fechaAplicacion
          ? new Date(vacunaData.fechaAplicacion)
          : new Date()
      );
      // En vez de setValue, usar reset para actualizar todo el formulario
      setValue(vacunaData.observacion ? vacunaData.observacion : "");
    }
  }, [isOpen, vacunaData, setValue]);

  // Efecto clave para integrar el comportamiento del modal de Bootstrap con React.
  // Se encarga de mostrar/ocultar el modal usando la API de JavaScript de Bootstrap.
  useEffect(() => {
    let bsModal; // Variable para almacenar la instancia del modal de Bootstrap

    // Verifica que el elemento del modal exista y que Bootstrap esté cargado en la ventana
    if (modalElementRef.current && typeof window.bootstrap !== "undefined") {
      // Inicializa una nueva instancia de Modal de Bootstrap
      bsModal = new window.bootstrap.Modal(modalElementRef.current, {
        backdrop: "static", // Evita que el modal se cierre al hacer clic fuera
        keyboard: false, // Evita que el modal se cierre con la tecla Escape
      });

      // Muestra u oculta el modal basado en el estado 'isOpen'
      if (isOpen) {
        bsModal.show();
      } else {
        bsModal.hide();
      }

      // Añade un event listener para cuando Bootstrap ha terminado de ocultar el modal.
      // Esto es crucial para sincronizar el estado de React con el estado interno de Bootstrap.
      const handleModalHidden = () => {
        if (isOpen) {
          // Solo llama a onClose si el modal fue abierto por el estado de React
          onClose(); // Llama a la función onClose para actualizar el estado del padre
        }
      };
      modalElementRef.current.addEventListener(
        "hidden.bs.modal",
        handleModalHidden
      );

      // Función de limpieza que se ejecuta cuando el componente se desmonta
      // o cuando 'isOpen' cambia de nuevo.
      return () => {
        if (bsModal) {
          bsModal.hide(); // Asegura que el modal esté oculto antes de destruirlo
          bsModal.dispose(); // Destruye la instancia del modal de Bootstrap para liberar recursos
        }
        // Elimina el event listener para evitar fugas de memoria
        if (modalElementRef.current) {
          modalElementRef.current.removeEventListener(
            "hidden.bs.modal",
            handleModalHidden
          );
        }
      };
    }
  }, [isOpen, onClose]); // Dependencias: el efecto se re-ejecuta cuando 'isOpen' o 'onClose' cambian

  // Función para manejar el envío del formulario
  const onSubmitForm = (formData) => {
    /* formData.preventDefault();  */ // Previene el comportamiento por defecto del formulario (recargar la página)
    const tempId = Math.floor(Math.random() * 1000000);
    // Crea un objeto con los datos a guardar
    const dataToSave = {
      /* id: tempId, */
      id_vacuna: vacunaData.id_vacuna,
      nombreVacuna: vacunaData.name,
      dosisInfo: vacunaData.dosisInfo, // Información de la dosis (ej: "0 meses")
      fechaAplicacion: fechaAplicacion.toISOString().split("T")[0],
      /* lote, */
      observacion: formData.observacion || "",
      edad: vacunaData.dosisInfo || "No especificada", // Campo adicional del backend
    };

    onSave(dataToSave); // Llama a la función onSave (pasada como prop) con los datos del formulario
    onClose(); // Cierra el modal después de guardar
  };

  // Si 'isOpen' es false, el componente no renderiza nada (React controlled visibility)
  if (!isOpen) {
    return null;
  }

  const handleDelete = () => {
    if (!vacunaData.id) return;

    dispatch(deleteRegistroVacuna(vacunaData.id));
    onClose(); // Cierra el modal
  };

  // JSX para el contenido del modal
  return (
    <div
      className="modal fade" // Clase de Bootstrap para un modal con animación de fade
      ref={modalElementRef} // Adjunta la referencia al elemento DOM
      id="registroVacunaModal" // ID único para el modal (puede ser usado por Bootstrap JS si no se usa ref)
      tabIndex="-1" // Permite que el modal reciba foco para accesibilidad
      aria-labelledby="registroVacunaModalLabel" // Asocia el título del modal para accesibilidad
      aria-hidden="true" // Indica que el modal está oculto por defecto para lectores de pantalla
    >
      <div className="modal-dialog modal-lg">
        {" "}
        {/* modal-dialog para la estructura, modal-lg para hacerlo más ancho */}
        <div className="modal-content">
          <div className="modal-header">
            {/*  <h5 className="modal-title" id="registroVacunaModalLabel">
              Registrar Vacuna: {vacunaData.name} - {vacunaData.dosisInfo}{" "} */}
            {/* Muestra info de la vacuna */}
            {/*  </h5> */}
            <button
              type="button"
              className="btn-close" // Botón de cierre de Bootstrap
              onClick={onClose} // Llama a onClose al hacer clic
              aria-label="Cerrar" // Etiqueta para accesibilidad
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={hookFormHandleSubmit(onSubmitForm)}>
              {" "}
              {/* Formulario para los datos */}
              {/* Campo para la Fecha de Aplicación */}
              <div className="w-full">
                <DatePickerComp
                  label="Fecha de Aplicación:"
                  startDate={fechaAplicacion}
                  onChange={setFechaAplicacion}
                  required
                />
              </div>
              {/* Campo para el Número de Lote */}
              {/* <div className="mb-3">
                <label htmlFor="lote" className="form-label">
                  Número de Lote:
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="lote"
                  value={lote}
                  onChange={(e) => setLote(e.target.value)}
                  required // Campo obligatorio
                />
              </div> */}
              {/* Campo para Observaciones */}
              <div className="mb-3">
                {/* <label htmlFor="observaciones" className="form-label">
                  Observaciones (opcional):
                </label> */}
                <Textarea
                  register={register("observacion")} // sin validación
                  name="observacion"
                  setValue={setValue}
                  getValue={getValues}
                  trigger={trigger}
                  label="Observaciones (opcional)"
                  placeholder={`Ej. Aplicación de ${
                    vacunaData.name || "la vacuna"
                  }`}
                  rows={3}
                />
              </div>
              {/* Botones de acción en el pie del modal */}
              <div className="modal-footer flex justify-end space-x-2">
                <Button
                  /* type="button"
                  className="btn btn-secondary" // Botón secundario para cancelar
                  onClick={onClose} */
                  label="Cancelar"
                  onClick={onClose}
                  variant="secondary"
                />
                {vacunaData.id && (
                  <Button
                    label="Eliminar"
                    onClick={handleDelete}
                    variant="danger"
                  />
                )}
                <Button
                  label="Guardar Registro"
                  type="submit"
                  variant="primary"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistroVacunaModal; // Exporta el componente para
